var React = require('react');

function Calendar (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M19 4H5C3.89543 4 3 4.89543 3 6V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V6C21 4.89543 20.1046 4 19 4Z","stroke":"black","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M16 2V6","stroke":"black","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M8 2V6","stroke":"black","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2}),React.createElement("path",{"d":"M3 10H21","stroke":"black","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":3})]);
}

Calendar.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Calendar;

Calendar.default = Calendar;
